export default __webpack_public_path__ + "static/media/icon-arrow-left.05cf2d8b.svg";